module.exports = __webpack_public_path__ + "static/media/Scolipede_gaussian2.258fb34b.png";